// TEMPORARY — the primary CTA saves the design and shows the ordering information (sku,
// reference code, description, size, engraving, price) instead of handing off to the
// storefront PDP, which is not ready to receive it yet. Staging keeps the handoff.
//
// To revert everywhere: set ENABLED to false. The modal in src/pages/index.tsx then
// goes unused and can be deleted.
//
// No-deploy escape hatch: ?orderInfoModal=off (or =on) toggles it for the rest of the
// browser session. Kept in sessionStorage, stripped from the URL when read.
const ENABLED = false;

// REACT_APP_ENVIRONMENT is 'production' | 'staging' | 'localhost'. Staging is out.
const MODAL_ENVIRONMENTS = ['production', 'localhost'];

const OVERRIDE_PARAM = 'orderInfoModal';
const OVERRIDE_SESSION_KEY = 'temp_order_info_modal_override';

/** Read ?orderInfoModal=on|off at import time, before the router sees the URL, then strip it. */
const captureOverrideFromUrl = () => {
  try {
    const url = new URL(window.location.href);
    const param = url.searchParams.get(OVERRIDE_PARAM);
    if (param !== 'on' && param !== 'off') {
      return;
    }
    sessionStorage.setItem(OVERRIDE_SESSION_KEY, param);
    url.searchParams.delete(OVERRIDE_PARAM);
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
  } catch (error) {
    // Storage can throw in private browsing; the env rule below is the fallback.
  }
};

captureOverrideFromUrl();

const getSessionOverride = (): boolean | null => {
  try {
    const stored = sessionStorage.getItem(OVERRIDE_SESSION_KEY);
    if (stored === 'on') return true;
    if (stored === 'off') return false;
  } catch (error) {
    // See above.
  }
  return null;
};

/** True when the primary CTA should open the ordering-information modal instead of the PDP handoff. */
export const showOrderInfoOnDone = (): boolean => {
  if (!ENABLED) {
    return false;
  }
  const override = getSessionOverride();
  if (override !== null) {
    return override;
  }
  return MODAL_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT || '');
};
